import {observer} from 'mobx-react';
import {FC, useEffect} from 'react';
import {Field} from 'apstra-ui-common';

import {maxPortChannelId} from '../const';
import NumberInput from './NumberInput';
import {useRackEditorStore} from '../hooks/useRackEditorStore';
import Node from '../store/Node';

import './PortChannelIdRange.less';

type PortChannelIdRangeProps = {
  minValue: number;
  maxValue: number;
  disabled?: boolean;
  asRange?: boolean;
  showOnlyMax?: boolean;
  onChange: (minValue: number, maxValue: number) => void;
  error: boolean;
  node: Node;
}

const PortChannelIdRange: FC<PortChannelIdRangeProps> = ({minValue, maxValue, disabled, asRange = false,
  showOnlyMax = false, onChange, error, node}) => {
  const {firstLabel, secondLabel, trackFocus} = usePortChannelIdRange(asRange, node);

  return (
    <>
      {
        (asRange || !showOnlyMax) &&
          <Field label={firstLabel} disabled={disabled} className='re-port-channel-id'>
            <NumberInput
              type='number'
              size='small'
              fluid
              value={minValue}
              min={0}
              max={maxPortChannelId}
              onChange={(event, {value}) => onChange(value, maxValue)}
              error={error}
              {...trackFocus}
            />
          </Field>
      }
      {
        (asRange || showOnlyMax) &&
          <Field label={secondLabel} disabled={disabled} className='re-port-channel-id'>
            <NumberInput
              type='number'
              size='small'
              fluid
              value={maxValue}
              min={0}
              max={maxPortChannelId}
              onChange={(event, {value}) => onChange(minValue, value)}
              error={error}
              {...trackFocus}
            />
          </Field>
      }
    </>
  );
};

export default observer(PortChannelIdRange);

const usePortChannelIdRange = (asRange: boolean, node: Node) => {
  const {rackStore} = useRackEditorStore();

  const firstLabel = asRange ? 'Min' : 'Port Channel ID';
  const secondLabel = asRange ? 'Max' : 'Port Channel ID';

  const managePortChannels = (state: Node | null) => {
    rackStore.setProperty('portChannelsAreManaged', state);
  };

  const trackFocus = {
    onFocus: () => managePortChannels(node),
    onBlur: () => managePortChannels(null)
  };

  useEffect(() => () => managePortChannels(null), []); // eslint-disable-line react-hooks/exhaustive-deps

  return {firstLabel, secondLabel, trackFocus};
};
